import axios from './axios.client.js';

// Get all notes
export const getNotes = async () => {
  try {
    const response = await axios.get('/notes');
    return response.data;
  } catch (error) {
    console.error('Error fetching notes:', error);
    throw error;
  }
};

// Get a single note
export const getNote = async (id) => {
  try {
    const response = await axios.get(`/notes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching note:', error);
    throw error;
  }
};

// Create a new note
export const createNote = async (noteData) => {
  try {
    const response = await axios.post('/notes', noteData);
    return response.data;
  } catch (error) {
    console.error('Error creating note:', error);
    throw error;
  }
};

// Update a note
export const updateNote = async (id, noteData) => {
  try {
    const response = await axios.put(`/notes/${id}`, noteData);
    return response.data;
  } catch (error) {
    console.error('Error updating note:', error);
    throw error;
  }
};

// Delete a note
export const deleteNote = async (id) => {
  try {
    const response = await axios.delete(`/notes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting note:', error);
    throw error;
  }
};

// Upload notes from CSV
export const uploadNotes = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post('/notes/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading notes:', error);
    throw error;
  }
};

// Extract note fields from text using NLP
export const extractNoteFields = async (text, provider = 'openai') => {
  try {
    const response = await axios.post('/notes/extract-fields', {
      text,
      provider,
    });
    return response.data;
  } catch (error) {
    console.error('Error extracting note fields:', error);
    throw error;
  }
};
